import React from 'react';
import { useWindowDimensions } from 'react-native';
import { isDesktopWeb } from '../../utils/platformDetection';
import { PantryMobile } from './mobile/PantryMobile';
import { PantryDesktop } from './desktop/PantryDesktop';

export function PantryScreen() {
  const { width } = useWindowDimensions();

  // Use desktop layout only on desktop web with sufficient width
  if (isDesktopWeb() && width > 1024) {
    return <PantryDesktop />;
  }

  return <PantryMobile />;
}
